import { IconEdit } from '../../../../icon/IconEdit';
import { Box } from '../../../../layout/Box';
import { Avatar } from '../../../../media/Avatar';
import { ProfileAvatarProps } from './types';

export const ProfileAvatar = ({
    avatarUrl,
    title,
    canEditBusiness,
    onPersistBusinessAvatar,
}: ProfileAvatarProps) => (
    <Box position="relative">
        <Avatar
            size={80}
            src={avatarUrl}
            title={title}
            border="1px solid var(--divider)"
            cursor={canEditBusiness ? 'pointer' : 'default'}
            onClick={canEditBusiness ? onPersistBusinessAvatar : undefined}
        />
        {canEditBusiness ? (
            <Box
                position="absolute"
                pointerEvents="none"
                bottom={0}
                right={0}
                p={0.75}
                borderRadius="50%"
                background="var(--control-secondary-background)"
                backdropFilter="blur(var(--blur-radius-l))"
            >
                <IconEdit size={16} color="var(--control-secondary-color)" />
            </Box>
        ) : null}
    </Box>
);
